import styled from "styled-components";

export const SignInBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1.25rem 0;
  width: 100%;
`;

export const SignInText = styled.div`
  font-family: ${(props) => props.theme.fonts.aeonik};
  font-style: normal;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25;

  display: flex;
  align-items: center;
  letter-spacing: 0.005em;
  color: ${(props) => props.theme.colors.neutrals.secondary.gray.indicator2};
`;

export const ContentWrapper = styled.div`
  width: 20rem;
  margin-top: 0.75rem;

  @media ${(props) => props.theme.device.sm} {
    width: 25rem;
  }
`;
